import React, {Component} from 'react';
import {NavLink} from 'react-router-dom';
import {Container, Dropdown, Icon, Image, Label, Menu} from 'semantic-ui-react';
import {connect} from "react-redux";

import {switchModeCalendrier} from "../actions/navigation";
import LogoMdv from '../images/logo-mediavision-blanc.png';

class CalcMenu extends Component {

  active = (path) => {
    return this.props.location.pathname.includes(path);
  }


  /*
   * Audience ciblée non encore connue
   * <Menu.Item to='./ecran-cible' as={NavLink} active={ this.active('ecran-cible') }>
   *   <Icon name='film'/><span>Campagne Écran - Audience Ciblée</span>
   * </Menu.Item>
   */
  render() {
    return (
        <Menu size='large' inverted>
          <Container>
            <Menu.Item><Image src={LogoMdv}/></Menu.Item>
            <Menu.Item header>Calculatrice</Menu.Item>
            <Dropdown item simple text='Campagne'>
              <Dropdown.Menu>
                <Menu.Item to='./ecran-ensemble' as={NavLink} active={ this.active('ecran-ensemble') }>
                  <Icon name='film'/><span>Campagne Écran - Audience Ensemble</span>
                </Menu.Item>
                
                <Menu.Item to='./numerique' as={NavLink} active={ this.active('numerique') }>
                  <Icon name='tv'/><span>Campagne numérique</span>
                </Menu.Item>
              </Dropdown.Menu>
            </Dropdown>
            <Menu.Menu position='right'>
              <Menu.Item onClick={this.props.switchCalendar}>
                <Icon name='calendar'/><span>{this.props.byMois ? 'Mois par mois' : 'Semaines glissantes'}</span>
              </Menu.Item>
              <Menu.Item to='./panier' as={NavLink} active={ this.active('panier') }>
                <Icon name='cart'/>
                Panier
                <Label circular color='teal'>{this.props.panierSize}</Label>
              </Menu.Item>
            </Menu.Menu>
          </Container>
        </Menu>
    );
  }
}

const mapStateToProps = (state) => ({
  byMois: state.navigation.byMois,
  location: state.router.location, // Requis pour la mise à jour de l'état des liens
  panierSize: state.panier.panier.length
});

const mapDispatchToProps = (dispatch) => ({
  switchCalendar: () => dispatch(switchModeCalendrier())
});

export default connect(mapStateToProps, mapDispatchToProps)(CalcMenu);
